// TODO: 以下是假資料，到時候替換成真的後，記得刪除
export const PLAN_OPTIONS = [
  {
    label: '黑卡會員',
    value: '黑卡會員',
  },
  {
    label: '金卡會員',
    value: '金卡會員',
  },
  {
    label: '銀卡會員',
    value: '銀卡會員',
  },
  {
    label: '銅卡會員',
    value: '銅卡會員',
  },
];

export const MEMBER_OPTIONS = [
  {
    label: '0987878787 朴敘俊',
    value: '0987878787 朴敘俊',
  },
  {
    label: '0966777666 河智苑',
    value: '0966777666 河智苑',
  },
  {
    label: '0933999111 韓佳人',
    value: '0933999111 韓佳人',
  },
  {
    label: '0955787321 孔劉',
    value: '0955787321 孔劉',
  },
  {
    label: '0951663774 申敏兒',
    value: '0951663774 申敏兒',
  },
  {
    label: '0946215368 玄彬',
    value: '0946215368 玄彬',
  },
];
